$(document).ready(function () {
  const clipboardInput = document.querySelectorAll('.clipboard');

  clipboardInput.forEach((clipboard) => {
    $(clipboard).on('click', function() {
      const copyText = $(clipboard).parents('.clipboard-container').find('.clipboard-copied-badge');

      let textToCopy = $(clipboard).find('small').text().trim();

      if (!!$(clipboard).find('small').data("url")) {
        textToCopy = $(clipboard).find('small').data("url").trim();
      }

      navigator.clipboard.writeText(textToCopy);

      copyText.addClass('d-flex');
      copyText.removeClass('d-none');

      setTimeout(() => {
        copyText.removeClass('d-flex');
        copyText.addClass('d-none');
      }, 2000);
    });
  })
});
